module.exports = __webpack_public_path__ + "static/img/zj06.7821370.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/zj06.png
// module id = 143
// module chunks = 0